import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { DateFieldFr } from '@/components/ui/date-field-fr';

const KIND = { avant_enregistrement: 'Version avant un enregistrement', enregistrement: 'Enregistrement manager', publication: 'Planning publié' };
const err = (e) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : 'Erreur réseau');

export const PurgedDaysReview = () => {
  const [range, setRange] = useState({ start: '2025-01-01', end: new Date().toISOString().slice(0, 10) });
  const [days, setDays] = useState(null);
  const search = async () => {
    try {
      const r = await axios.get(`${API}/schedule/integrity/purged-days?start_date=${range.start}&end_date=${range.end}`);
      setDays(r.data.days);
    } catch (e) { toast.error(err(e)); }
  };
  const restore = async (d, src) => {
    if (!window.confirm(`Recréer la journée du ${d.date} depuis « ${KIND[src.kind]} » ? Rien n'est écrasé : refusé si une journée existe déjà.`)) return;
    try {
      await axios.post(`${API}/schedule/integrity/purged-days/restore`, { user_id: d.user_id, date: d.date, kind: src.kind, ref: src.ref });
      toast.success('Journée recréée'); search();
    } catch (e) { toast.error(err(e)); search(); }
  };
  return (
    <section data-testid="purged-days-section">
      <h2 className="mb-1 text-lg font-semibold">Journées supprimées retrouvables dans les traces</h2>
      <p className="mb-2 text-sm text-slate-600">Journées absentes de la base mais présentes dans un enregistrement ou un planning publié. Chaque recréation est volontaire et n’écrase jamais une journée existante.</p>
      <div className="flex flex-wrap items-end gap-2">
        <DateFieldFr value={range.start} onChange={(v) => setRange({ ...range, start: v })} testid="purged-start" />
        <DateFieldFr value={range.end} onChange={(v) => setRange({ ...range, end: v })} testid="purged-end" />
        <Button onClick={search} data-testid="purged-search-btn">Rechercher</Button>
      </div>
      {days && days.length === 0 && <p className="mt-2 text-sm text-emerald-700" data-testid="purged-empty">Aucune journée manquante retrouvée sur cette période.</p>}
      <div className="mt-2 space-y-2">
        {(days || []).map((d) => (
          <div key={`${d.user_id}|${d.date}`} className="rounded border bg-white p-2 text-xs" data-testid={`purged-day-${d.user_id}-${d.date}`}>
            <p className="font-medium">{d.user_name || d.user_id} — {new Date(`${d.date}T12:00:00`).toLocaleDateString('fr-FR')}</p>
            {d.sources.map((src) => (
              <div key={`${src.kind}-${src.ref}`} className="mt-1 flex flex-wrap items-center gap-2">
                <span>{KIND[src.kind] || src.kind} · {src.at ? new Date(src.at).toLocaleString('fr-FR') : ''}{src.by ? ` · ${src.by}` : ''} · statut « {src.row?.status || '—'} »{src.row?.tour_type ? ` · ${src.row.tour_type}` : ''}</span>
                {src.kind !== 'enregistrement' && (
                  <Button size="sm" variant="outline" onClick={() => restore(d, src)} data-testid={`purged-restore-${src.ref}-${d.date}`}>Recréer depuis cette trace</Button>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
